import Icon from "@mui/material/Icon";
import { useTheme } from "@mui/material/styles";
import { Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => {
	const { palette } = useTheme();

	return (
		<CssColumnGrid columns={5}>
			<Text semiBold text="regular" />
			<Text semiBold text="solid" />
			<Text semiBold text="error (small)" />
			<Text semiBold text="primary" />
			<Text semiBold text="custom (large)" />
			<Icon className="far fa-file" />
			<Icon className="fas fa-file" />
			<Icon
				className="far fa-file"
				color="error"
				fontSize="small"
			/>
			<Icon className="far fa-file" color="primary" />
			<Icon
				className="far fa-file"
				fontSize="large"
				style={{ color: palette.LinkDefault }}
			/>
		</CssColumnGrid>
	);
};